import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "c-co-header" }

import {onMounted, ref, watch} from "vue";
import CommonDatepicker from "@/components/common/CommonDatepicker.vue";
import {SearchMd} from "utruckin-icons";
import CommonDropdown from "./CommonDropdown.vue";
import CustomSearch from "@/components/custom/CustomSearch.vue";
import CustomTab from "@/components/custom/CustomTab.vue";
import {IShift} from "@/features/shifts/shifts.types";
import {useShiftStore} from "@/features/shifts/shifts.store";
import {ICommonFilterProps, IDropdown} from "@/types/main";
import {useAppStore} from "@/store/app.store";
import {useAccountStore} from "@/features/account/account.store";
import {IAccount} from "@/features/account/account.types";
import {DateTime} from 'luxon'


export default /*@__PURE__*/_defineComponent({
  __name: 'CommonFilter',
  props: {
    withSearch: { type: Boolean, default: true },
    withDate: { type: Boolean, default: true },
    withAccount: { type: Boolean, default: true },
    withOutgoing: { type: Boolean, default: true },
    withShift: { type: Boolean, default: true },
    store: {},
    loading: { type: Boolean, default: true },
    noDate: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props;

const activeTab = ref<number>(0);
const search = ref<string>('');
let debounceTimer: ReturnType<typeof setTimeout> | null = null
// accounts
const accountType = ref(0);
const accountLoading = ref<boolean>(false);
const accounts = ref<IDropdown[]>([])
// shifts
const shiftLoading = ref<boolean>(false);
const shifts = ref<IDropdown[]>([])
const shiftType = ref(0);

const today = new Date()
const yesterday = new Date()
yesterday.setDate(today.getDate() - 1)

const shiftStore = useShiftStore()
const accountStore = useAccountStore()
const appStore = useAppStore()

const tabs = [
  {label: "All", value: 0},
  {label: "Sent", value: 1},
  {label: "Received", value: 2},
]

function datepickerToUtcDateOnly(d: Date | null | undefined) {
  if (!d) return ''
  const local = DateTime.fromJSDate(d)
  return DateTime.utc(local.year, local.month, local.day).toFormat('yyyy-MM-dd')
}

const handleDateUpdate = (startDate: Date, endDate: Date) => {
  props.store.commonFilter.date_from = datepickerToUtcDateOnly(startDate);
  props.store.commonFilter.date_to = datepickerToUtcDateOnly(endDate);

  props.store.commonFilter.page = 1
  props.store.commonFilter.page_size = 50
}

const getShifts = async () => {
  shifts.value = []

  shiftStore.shiftsForFilter = await shiftStore.getShifts(shiftLoading, true)

  if (shiftStore.shiftsForFilter.length) {
    shiftStore.shiftsForFilter.forEach((item: IShift) => {
      shifts.value.push({name: item.title, value: item.id});
    })

    shifts.value.unshift({name: "All shift", value: 0});
  }
}

const getAccounts = async () => {
  accounts.value = []

  accountStore.accountsForFilter = await accountStore.getAccounts(accountLoading)

  if (accountStore.accountsForFilter.length) {
    accountStore.accountsForFilter.forEach((item: IAccount) => {
      accounts.value.push({name: item.session_name, value: item.id});
    })

    accounts.value.unshift({name: "All accounts", value: 0});
  }
}

onMounted(() => {
  function getUtcDateOnlyFromLocal(dt: DateTime) {
    return DateTime
        .utc(dt.year, dt.month, dt.day)
        .toFormat('yyyy-MM-dd')
  }

  const yesterdayLocal = DateTime.local().minus({days: 1})

  if (props.store && props.withDate && !props.noDate) {
    props.store.commonFilter.date_from = getUtcDateOnlyFromLocal(yesterdayLocal)
    props.store.commonFilter.date_to = getUtcDateOnlyFromLocal(DateTime.local())
  }

  getShifts()
  getAccounts()
})

watch(
    () => appStore.refreshKey,
    () => {
      getShifts()
      getAccounts()
    }
)

watch(
    () => search.value,
    (newSearch) => {
      if (debounceTimer) {
        clearTimeout(debounceTimer)
      }

      debounceTimer = setTimeout(() => {
        const value = newSearch?.trim() || ''

        if (value.length >= 4) {
          props.store.commonFilter.q = value
        } else if (value.length === 0) {
          props.store.commonFilter.q = ''
        } else {
          return
        }

        props.store.commonFilter.page = 1
        props.store.commonFilter.page_size = 50
      }, 500)
    }
)

watch(
    () => shiftType.value,
    (newShiftType) => {
      if (newShiftType == 0) {
        props.store.commonFilter.shift_id = null;
      } else {
        props.store.commonFilter.shift_id = newShiftType;
      }

      props.store.commonFilter.page = 1
      props.store.commonFilter.page_size = 50
    }, {
      immediate: false,
    }
)

watch(
    () => accountType.value,
    (newAccountType) => {
      if (newAccountType == 0) {
        props.store.commonFilter.account = null;
      } else {
        props.store.commonFilter.account = newAccountType;
      }

      props.store.commonFilter.page = 1
      props.store.commonFilter.page_size = 50
    }, {
      immediate: false,
    }
)

watch(
    () => activeTab.value,
    (newActiveTab) => {
      if (newActiveTab == 0) {
        props.store.commonFilter.outgoing = null;
      } else props.store.commonFilter.outgoing = newActiveTab == 1;

      props.store.commonFilter.page = 1
      props.store.commonFilter.page_size = 50
    }, {
      immediate: false,
    }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.withSearch)
      ? (_openBlock(), _createBlock(CustomSearch, {
          key: 0,
          modelValue: search.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search).value = $event)),
          icon: _unref(SearchMd),
          placeholder: "Users"
        }, null, 8, ["modelValue", "icon"]))
      : _createCommentVNode("", true),
    (__props.withDate)
      ? (_openBlock(), _createBlock(CommonDatepicker, {
          key: 1,
          mode: "range",
          "default-range": __props.noDate ? {} : {
            fromDate: new Date((_unref(yesterday))),
            toDate: new Date((_unref(today))),
          },
          "max-days-range": 30,
          "is-two-sinded": true,
          placement: "right",
          clearable: true,
          onUpdate: handleDateUpdate
        }, null, 8, ["default-range"]))
      : _createCommentVNode("", true),
    (__props.withAccount)
      ? (_openBlock(), _createBlock(CommonDropdown, {
          key: 2,
          modelValue: accountType.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((accountType).value = $event)),
          label: "Accounts",
          items: accounts.value,
          disabled: !accounts.value.length || accountLoading.value 
        }, null, 8, ["modelValue", "items", "disabled"]))
      : _createCommentVNode("", true),
    (__props.withShift)
      ? (_openBlock(), _createBlock(CommonDropdown, {
          key: 3,
          modelValue: shiftType.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((shiftType).value = $event)),
          label: "All shift",
          items: shifts.value,
          disabled: !shifts.value.length || shiftLoading.value
        }, null, 8, ["modelValue", "items", "disabled"]))
      : _createCommentVNode("", true),
    (__props.withOutgoing)
      ? (_openBlock(), _createBlock(CustomTab, {
          key: 4,
          tabs: tabs,
          modelValue: activeTab.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((activeTab).value = $event))
        }, null, 8, ["modelValue"]))
      : _createCommentVNode("", true)
  ]))
}
}

})